 require('./datepicker');require('./dateformat')
riot.tag2('booking-calendar', '<div> <div class="panel panel-default"> <div class="panel-heading"> <h5 class="panel-title">{opts.name} Availability</h5> </div> <div class="panel-body"> <div class="row"> <div class="col-md-4 col-sm-12 col-xs-12"> <div class="calbox"> <datepicker date="{new Date()}" onupdate="{handledatechange}" datestyle="{datestyle}"> </datepicker> </div> </div> <div if="{!opening.length}" class="col-md-8 col-sm-12 col-xs-12"> <h4>Sorry, booking is not availble on this date.</h4> <p>Please choose another date.</p> </div> <div if="{opening.length}" class="col-md-4 col-sm-6 col-xs-12"> <h4> <dateformat date="{today}" format="dd MMMM yyyy"></dateformat> </h4> <div class="day"> <div each="{hr, i in opening}" onclick="{choosetime.bind(null,hr)}" class="hours {hourfree(hr)}"> <span class="time">{hr}:00</span></div> </div> </div> <div if="{opening.length &amp;&amp; today&lt;=new Date()}" class="col-md-4 col-sm-6 col-xs-12"> <div class="alert alert-info"> You have chosen a date in the past. You can view calendar entries but not add to them. </div> </div> <div if="{opening.length &amp;&amp; today&gt;new Date()}" class="col-md-4 col-sm-6 col-xs-12"> <h4>Add Booking</h4> <form class="form-horizontal"> <formselect label="Start" name="start_time" value="{start}" options="{openingTimes}" onupdate="{timeUpdate}" default="choose" class="form-group-sm"></formselect> <formselect label="End" name="end_time" value="{end}" options="{closingTimes}" onupdate="{timeUpdate}" default="choose" class="form-group-sm"></formselect> <formcheckbox each="{times.presets}" show="{parent.showPreset(open,close)}" label="{name}" oninput="{setPreset}" value="{parent.isPreset(open,close,type)}" class="form-group-sm"></formcheckbox> <div class="btn-toolbar pull-right"> <p>Price: £{price}.00</p> <button __disabled="{!price}" onclick="{addToBasket}" class="btn btn-primary">Add to Basket</button> </div> </form> </div> </div> <div if="{myevents.length}" class="row"> <div class="col-xs-12"> <h4>My Bookings</h4> <table class="table table-striped"> <thead> <tr> <th> </th> <th>Start Time </th> <th>End Time </th> </tr> </thead> <tbody> <tr each="{myevents}"> <td> <div title="remove booking" onclick="{parent.removeBooking}" class="btn btn-primary btn-sm">&times;</div> </td> <td> <dateformat date="{new Date(from)}" format="dd MMMM yyyy - HH:mm"></dateformat> </td> <td> <dateformat date="{new Date(to)}" format="dd MMMM yyyy - HH:mm"></dateformat> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div>', 'booking-calendar .calbox { border: 1px solid #eee; margin: 15px 0px; } booking-calendar .calbox datepicker { display: block; padding: 10px; } booking-calendar .calbox datepicker table { width: 100%; } booking-calendar .calbox datepicker table td, booking-calendar .calbox datepicker table th { text-align: center; } booking-calendar .form-group { margin-bottom: 5px; } booking-calendar .form-group-sm .checkbox { font-size: 14px; } booking-calendar .calday.event { font-weight: bold; } booking-calendar .calday.inactive { opacity: 0.2; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)"; filter: alpha(opacity=20); } booking-calendar .calday.btn { border-radius: 2px; border: 0px; padding: 2px; display: table-cell; } booking-calendar .day { margin: 30px 0; } booking-calendar .hours { position: relative; margin-left: 40px; padding-left: 5px; font-size: 14px; border-left: 5px solid #fff; border-top: 1px solid #ddd; height: 20px; } booking-calendar .hours .time { position: absolute; top: -10px; left: -50px; width: 40px; text-align: right; } booking-calendar .hours.event { background: #eee; background-image: -webkit-repeating-linear-gradient(135deg, #eee, #eee 7px, #fff 7px, #fff 14px); background-image: -moz-repeating-linear-gradient(135deg, #eee, #eee 7px, #fff 7px, #fff 14px); background-image: -o-repeating-linear-gradient(135deg, #eee, #eee 7px, #fff 7px, #fff 14px); background-image: -ms-repeating-linear-gradient(135deg, #eee, #eee 7px, #fff 7px, #fff 14px); background-image: repeating-linear-gradient(-45deg, #eee, #eee 7px, #fff 7px, #fff 14px); } booking-calendar .hours.chosen { border-left: 5px solid #888; border-left-color: var(--primary-color); } booking-calendar .busy { background: rgba(133,184,208,0.3); float: left; width: 15px; height: 15px; margin: 0px 5px 5px 10px; }', '', function(opts) {
this.on("mount", function() {
  this.pricing = opts.pricing || {};
  this.times = opts.times || [];
  this.events = [];
  this.today = new Date();
  this.basket = document.querySelector("[riot-tag=popup-basket]");
  return this.getMonth();
});

this.calcopening = (function(_this) {
  return function() {
    var close_h, h, open_h, ref, ref1, ref2, results, timerow, timerow_c, times;
    if (!_this.times) {
      return;
    }
    times = (ref = _this.times.days) != null ? (ref1 = ref[_this.today.getDay()]) != null ? ref1[0] : void 0 : void 0;
    if ((ref2 = _this.times.dates) != null) {
      ref2.forEach(function(dt) {
        if (_this.today >= new Date(dt.start) && _this.today <= new Date(dt.end)) {
          return times = dt.hours[0];
        }
      });
    }
    _this.opening = [];
    _this.openingTimes = [];
    _this.closingTimes = [];
    if (!(times != null ? times.open : void 0) || !(times != null ? times.close : void 0)) {
      return;
    }
    open_h = +times.open.match(/^[^:]+/);
    close_h = +times.close.match(/^[^:]+/);
    h = open_h;
    results = [];
    while (h <= close_h) {
      _this.opening.push(h);
      timerow = {
        label: h + ":00",
        value: h
      };
      timerow_c = {
        label: 1 + h + ":00",
        value: 1 + h
      };
      if (_this.hourfree(h).match(/event/)) {
        timerow.disabled = true;
      }
      if (_this.hourfree(h).match(/event/)) {
        timerow_c.disabled = true;
      }
      _this.openingTimes.push(timerow);
      if (timerow_c.value <= close_h) {
        _this.closingTimes.push(timerow_c);
      }
      results.push(h++);
    }
    return results;
  };
})(this);

this.on("update", function() {
  var ref;
  this.calcopening();
  this.price = 0;
  if (this.pricing) {
    this.pricetype = "";
    if ((ref = this.times) != null ? ref.presets : void 0) {
      this.times.presets.forEach((function(_this) {
        return function(p) {
          if (_this.start === +p.open.match(/^[^:]+/)[0] && _this.end === +p.close.match(/^[^:]+/)[0]) {
            return _this.pricetype = p.type;
          }
        };
      })(this));
    }
    return this.price = (function() {
      switch (this.pricetype) {
        case "halfday":
          return this.pricing.halfday;
        case "day":
          return this.pricing.day;
        default:
          return this.pricing.hour * (this.end - this.start);
      }
    }).call(this);
  }
});

this.handledatechange = (function(_this) {
  return function(date) {
    _this.today = date;
    _this.start = "";
    _this.end = "";
    _this.update();
    return _this.getMonth();
  };
})(this);

this.dateformat = (function(_this) {
  return function(date) {
    return date.getFullYear() + "-" + (1 + date.getMonth()) + "-" + date.getDate();
  };
})(this);

this.timeformat = (function(_this) {
  return function(date) {
    return date.getHours() + ":00";
  };
})(this);

this.monthbegin = (function(_this) {
  return function(date) {
    var dt;
    dt = new Date(date);
    return new Date(dt.setDate(1));
  };
})(this);

this.monthend = (function(_this) {
  return function(date) {
    var dt;
    dt = new Date(date);
    return new Date(new Date(dt.setMonth(dt.getMonth() + 1)).setDate(0));
  };
})(this);

this.getMonth = (function(_this) {
  return function(force) {
    var end, start;
    if (_this.month === _this.today.getMonth() && !force) {
      return;
    }
    _this.month = _this.today.getMonth();
    start = _this.dateformat(_this.monthbegin(_this.today));
    end = _this.dateformat(_this.monthend(_this.today));
    return _this.getBusy(start, end);
  };
})(this);

this.getBusy = (function(_this) {
  return function(start, end) {
    var xhr;
    if (window.location.search.match(/editmode/)) {
      return;
    }
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      var events;
      if (xhr.readyState === 4) {
        events = JSON.parse(xhr.responseText).data;
        _this.events = events.map(function(ev) {
          return {
            start: new Date(ev.from),
            end: new Date(ev.to)
          };
        });
        _this.start = "";
        _this.end = "";
        _this.myevents = events.filter(function(ev) {
          return ev.type === "temp";
        });
        return _this.update();
      }
    };
    xhr.open('GET', "/duocms/api/bookings/asset/" + opts.productid + "?start=" + start + "&end=" + end, true);
    return xhr.send();
  };
})(this);

this.choosetime = (function(_this) {
  return function(hr) {
    if (_this.hourfree(hr) === "") {
      _this.chosen = new Date(new Date(_this.today).setHours(hr));
      _this.chosen_format = _this.dateformat(_this.chosen) + " " + _this.timeformat(_this.chosen);
      return _this.update();
    }
  };
})(this);

this.timeUpdate = (function(_this) {
  return function(arg) {
    var name, value;
    name = arg.name, value = arg.value;
    if (name === "start_time") {
      _this.start = +value;
      if (!_this.end || _this.end <= _this.start) {
        _this.end = _this.start + 1;
      }
    }
    if (name === "end_time") {
      _this.end = +value;
      if (!_this.start || _this.end <= _this.start) {
        _this.start = _this.end - 1;
      }
    }
    return _this.update();
  };
})(this);

this.hourfree = (function(_this) {
  return function(hr) {
    var ev, i, len, ref, style;
    style = "";
    if (!hr) {
      return "";
    }
    if (hr >= _this.start && hr < _this.end) {
      style = "chosen";
    }
    ref = _this.events;
    for (i = 0, len = ref.length; i < len; i++) {
      ev = ref[i];
      if (_this.today.toDateString() === ev.start.toDateString() && ev.start.getHours() <= hr && ev.end.getHours() > hr) {
        style += " event";
      }
    }
    return style;
  };
})(this);

this.datestyle = (function(_this) {
  return function(date) {
    var ev, i, len, ref, style;
    ref = _this.events;
    for (i = 0, len = ref.length; i < len; i++) {
      ev = ref[i];
      style = "";
      if (date.toDateString() === ev.start.toDateString()) {
        style += "event btn btn-default";
      }
    }
    if (date.toDateString() === _this.today.toDateString()) {
      style += " active btn btn-primary";
    }
    return style;
  };
})(this);

this.setPreset = (function(_this) {
  return function(e) {
    _this.start = +e.item.open.match(/^[^:]+/)[0];
    _this.end = +e.item.close.match(/^[^:]+/)[0];
    return _this.update();
  };
})(this);

this.isPreset = (function(_this) {
  return function(open, close, type) {
    return _this.start === +open.match(/^[^:]+/)[0] && _this.end === +close.match(/^[^:]+/)[0];
  };
})(this);

this.showPreset = (function(_this) {
  return function(open, close) {
    var end, i, results, show, start;
    start = +open.match(/^[^:]+/)[0];
    end = +close.match(/^[^:]+/)[0];
    return show = _this.opening.indexOf(start) > -1 && _this.opening.indexOf(end) > -1 && !((function() {
      results = [];
      for (var i = start; start <= end ? i < end : i > end; start <= end ? i++ : i--){ results.push(i); }
      return results;
    }).apply(this).filter(function(h) {
      return _this.hourfree(h).match(/event/);
    })).length;
  };
})(this);

this.addToBasket = (function(_this) {
  return function(e) {
    var end, start, xhr;
    if (e != null) {
      e.preventDefault();
    }
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (_this.basket) {
          _this.basket.trigger('updateBasket');
        }
        _this.getMonth(true);
        return _this.update();
      }
    };
    start = new Date(_this.today.setHours(_this.start, 0, 0, 0)).toUTCString();
    end = new Date(_this.today.setHours(_this.end, 0, 0, 0)).toUTCString();
    xhr.open('GET', "/duocms/api/bookings/basket?id=" + opts.productid + "&start=" + start + "&end=" + end, true);
    return xhr.send();
  };
})(this);

this.removeBooking = (function(_this) {
  return function(e) {
    var end, id, idx, start, xhr;
    if (e != null) {
      e.preventDefault();
    }
    idx = e.item.id;
    id = opts.productid;
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (_this.basket) {
          _this.basket.trigger('updateBasket');
        }
        _this.getMonth(true);
        return _this.update();
      }
    };
    start = new Date(_this.today.setHours(_this.start, 0, 0, 0)).toUTCString();
    end = new Date(_this.today.setHours(_this.end, 0, 0, 0)).toUTCString();
    xhr.open('DELETE', "/duocms/api/bookings/basket?id=" + id + "&idx=" + idx + "&_csrf=" + window.csrf, true);
    return xhr.send();
  };
})(this);
});